import React, { PureComponent } from 'react';
import { Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
class Product extends PureComponent {
	redirectToDetail = () => {
		// console.log('props', this.props);
		this.props.history.push({
			pathname: `clientwebsite/productDetail/${this.props.media.imageId}`,
			// Change later to /productDetail
			state: {
				media: this.props.media,
				whatsappLink: this.props.whatsappLink,
				businessName: this.props.businessName,
			},
		});
	};
	render() {
		const { selected, dashboard } = this.props
		if (this.props.media.productName) {
			return (
				<div onClick={() => {
					if (dashboard) {
						this.props.addToCart(this.props.media)
					} else
						this.redirectToDetail()
				}} key={this.props.media.imageId} className="exploreProductDetailContainer">
					{selected ?
						<Image
							className="notSelected"
							src="/assets/images/svgs/Error.svg"
						/>
						: <div className="emptyDiv"></div>
					}
					<div className={`imageDiv ${selected ? "selectedImage" : ""}`}>
						<Image src={this.props.media.imageUrl} alt={this.props.media.productName} />
					</div>
					<div className="prodInfo">
						<h4 className="productName">
							{this.props.media.productName ? this.props.media.productName : ''}
						</h4>

						<h3 className={"productPrice"}>
							{this.props.media.price ? (
								<div>
									<span>{this.props.media.currency}</span>
									{this.props.media.price}
								</div>
							) : (
									''
								)}
						</h3>
					</div>
				</div>

			);
		} else
			return (
				<div onClick={() => {
					if (dashboard) {
						this.props.addToCart(this.props.media)
					} else
						this.redirectToDetail()
				}} key={this.props.media.imageId} className="productDetailContainer">
					{selected ?
						<Image
							className="notSelected"
							src="/assets/images/svgs/Error.svg"
						/>
						: <div className="emptyDiv"></div>
					}
					<div className={`imageDiv ${selected ? "selectedImage" : ""}`}>
						<Image src={this.props.media.imageUrl} alt={this.props.media.productName} />
					</div>
					<h4>
						{/* Product Name */}
						{/* 1234567 901234 678 */}
						{this.props.media.productName ? this.props.media.productName : ''}
					</h4>

					<h3>
						{this.props.media.price ? (
							<div>
								<span>KD</span>
								{this.props.media.price}
							</div>
						) : (
								''
							)}
					</h3>
				</div>
			);
	}
}

export default withRouter(Product);



// WEBPACK FOOTER //
// ./src/components/MainPageProduct.js